import type { IKpiRepository } from '../repositories/IKpiRepository.js';
import type { KpiValueEntity } from '../entities/KpiEntity.js';

export function createListKpiValuesByProjectUseCase({ kpiRepository }: { kpiRepository: IKpiRepository }) {
  return (orgId: string, projectId: string, filters?: { locationId?: string; createdBy?: string; dateFrom?: string; dateTo?: string }): Promise<KpiValueEntity[]> =>
    kpiRepository.listValuesByProject(orgId, projectId, filters);
}
